import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import AuthSlice from "../store/Authslice";
import { useState } from "react";
import Metadata from "./Metadata";

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const dispatch = useDispatch();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                "https://dummyjson.com/auth/login",
                {
                    username: "emilys",
                    password: "emilyspass",
                    expiresInMins: 30,
                }
            );
            if (response.status === 200) {
                console.log(response)
                dispatch(AuthSlice.actions.setAuthValue(response.data.accessToken));
                localStorage.setItem("authToken", response.data.accessToken);
                console.log("sujith")
                console.log(response.data.accessToken)
               
                navigate("/cart");
            }
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <section id="login-box">
            <form onSubmit={handleSubmit}>
                <div class="container py-4" >
                    <div class="row ">
                        <div class="col-lg-4 mx-auto d-block" >
                            <h1 class="text-center my-4">Login</h1>

                            <input type="text" class="form-control my-3 inputelements p-2" name="user-email" id="useremaica" placeholder="Email" onChange={(event) => { setEmail(event.target.value) }} required />
                            <input type="password" class="form-control my-3 inputelements p-2" name="user-password" id="userpwdca" placeholder="password" onChange={(event) => { setPassword(event.target.value) }} required />

                            <button class="btn mx-auto d-block acc-btn p-2 btn-primary" >Login </button>
                        </div>

                    </div>
                </div>
            </form>
        </section>


    )

}
export default Login;
